import React, { useEffect, useRef } from 'react';

const SCRIPT_ID = 'CookieDeclaration';

/**
 * Renders Cookiebot's cookie declaration.
 */

const CookieDeclaration = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (!container || document.getElementById(SCRIPT_ID)) {
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://consent.cookiebot.com/${process.env.NEXT_PUBLIC_COOKIEBOT_DOMAIN_GROUP}/cd.js`;
    script.type = 'text/javascript';
    script.async = true;

    container.appendChild(script);
  }, []);

  return <div ref={containerRef} />;
};

export default CookieDeclaration;
